module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-down-light.49404353.svg";